export const writing = [
  {
    id: "writingType",
    type: "dropdown",
    choices: [
      "Essay (argumentative, persuasive, analytical)",
      "Story (fiction, creative writing)",
      "Article (blog post, news article, technical writing)",
      "Report (business, academic)",
      "Poem",
      "Script (screenplay, dialogue)",
      "Social Media Post",
    ],
  },
  {
    id: "topic",
    type: "textarea",
    placeholder: "Enter the topic or subject matter of your writing",
  },
  {
    id: "keywords",
    type: "textarea",
    placeholder: "Enter relevant keywords to be included in the writing",
  },
  {
    id: "style",
    type: "dropdown",
    choices: [
      "Natural",
      "Professional",
      "Casual",
      "Formal",
      "Informal",
      "Humorous",
      "Persuasive",
      "Descriptive",
    ],
  },
  {
    id: "audience",
    type: "textarea",
    placeholder: "Who is the intended audience for this writing?",
  },
  {
    id: "purpose",
    type: "dropdown",
    choices: ["Inform", "Persuade", "Entertain", "Educate", "Inspire"],
  },
  {
    id: "length",
    type: "dropdown",
    choices: [
      "Short (under 500 words)",
      "Medium (500-1000 words)",
      "Long (over 1000 words)",
    ],
  },
  {
    id: "revision",
    type: "radio",
    choices: ["Yes", "No"],
  },
  {
    id: "existingText",
    type: "textarea",
    placeholder: "Paste the existing text here for revision",
    conditional: (opts) => opts.revision === "Yes",
  },
  {
    id: "additionalInstructions",
    type: "textarea",
    placeholder: "Provide any specific requirements, examples, or preferences",
  },
];
